import KeepRate from './rate.vue';
export default KeepRate;
